import { render } from "./AddEditStock.vue?vue&type=template&id=fc8640ee&scoped=true"
import script from "./AddEditStock.vue?vue&type=script&lang=js"
export * from "./AddEditStock.vue?vue&type=script&lang=js"

import "./AddEditStock.vue?vue&type=style&index=0&id=fc8640ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8640ee"]])

export default __exports__